import MainRouter from "./routes/MainRoute";
import { BrowserRouter } from "react-router-dom";

function App() {
  return (
    // <>
    //   <h3>This website has been shutdown. </h3>
    //   <p>Please contact us at <a href="mailto:info@myechelon.co">info@myechelon.co</a></p>
      

    // </>
    <BrowserRouter>
      <MainRouter />
    </BrowserRouter>
  );
}

export default App;
